import { createFileRoute, redirect } from '@tanstack/react-router'
import { ROUTE_PATHS } from '@/config/app.config'
import { useAuthStore } from '@/features/auth/stores/auth.store'
import { LoginPage } from '@/features/auth'

/**
 * `/admin` — admin sign-in via email/password against `POST /admin/auth/login`.
 *
 * Separate from the main `/login` flow (SSO + email OTP + MFA). After login the
 * profile is resolved via `GET /auth/me`: a `null` tenant marks the AMLiQ super
 * admin, otherwise the backend role applies. Already-authenticated visitors are
 * bounced home.
 */
export const Route = createFileRoute('/admin')({
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: ROUTE_PATHS.root })
    }
  },
  component: LoginPage,
})
